import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AES, enc } from 'crypto-ts';


// @Injectable({
//     providedIn: 'root'
// })
// export class interceptorD4Headers implements HttpInterceptor {
//     private urlsWithoutSubscriber: string[] = [];
//     constructor(private deviceService: deviceService) {
//         //TODO add list of URL where subscriber must be read from LocalStorage
//         this.urlsWithoutSubscriber = [
//             'https://admin.digit4ll.net/api/v1/apps',
//             'https://admin.digit4ll.net/api/v1/me',
//             'https://admin.digit4ll.net/api/v1/access',
//             'https://admin.digit4ll.dev/api/v2/apps',
//             'https://admin.digit4ll.dev/api/v2/me',
//             'https://admin.digit4ll.dev/api/v2/access',
//             'https://admin.digit4ll.dev/api/v1/apps',
//             'https://admin.digit4ll.dev/api/v1/me',
//             'https://admin.digit4ll.dev/api/v1/access'
//         ];
//     }


function getDeviceUUID(): string {
  //let uuid = uuidv5('https://digit4ll.com', uuidv5.DNS);
  return 'cd7e9450-e693-53df-bc25-027bc3939889';
}

function decryptDataLocalStorage(objectName: string): any | null {
  try {
    let guid = getDeviceUUID();
    let resp = localStorage.getItem(objectName);
    if (resp != null && resp != 'null') {
      let bytes = AES.decrypt(resp, guid);
      if (bytes != null) {
        let decodeValue = JSON.parse(bytes.toString(enc.Utf8).toString());
        return decodeValue;
      }
    }
    //data receive by shared/iframe website() should be save on localstortage when event is received
    return null;
  } catch (e) {
    console.log("Fichier utilisateur corrompus, merci d'effacer les données de l'application");
    return null;
  }
}


export function intercept(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // add authorization header with jwt token if available
  let urlsWithoutSubscriber = [
    'https://admin.digit4ll.net/api/v1/apps',
    'https://admin.digit4ll.net/api/v1/me',
    'https://admin.digit4ll.net/api/v1/access',
    'https://admin.digit4ll.dev/api/v2/apps',
    'https://admin.digit4ll.dev/api/v2/me',
    'https://admin.digit4ll.dev/api/v2/access',
    'https://admin.digit4ll.dev/api/v1/apps',
    'https://admin.digit4ll.dev/api/v1/me',
    'https://admin.digit4ll.dev/api/v1/access',
  ];

  let resp = decryptDataLocalStorage('userSession');
  if (resp != null) {
    let subscriberId = '00000000000000000000000000000000';
    let SubscriberHost = '';
    let SubscriberDatabaseName = '';
    let SubscriberDatabasePort = '0';

    if (!urlsWithoutSubscriber.includes(request.url)) {
      if (decryptDataLocalStorage('currentSubscriberID') != null)
        subscriberId = decryptDataLocalStorage('currentSubscriberID');
      if (decryptDataLocalStorage('subscriberHost') != null)
        SubscriberHost = decryptDataLocalStorage('subscriberHost');
      if (decryptDataLocalStorage('subscriberDatabaseName') != null)
        SubscriberDatabaseName = decryptDataLocalStorage('subscriberDatabaseName');
      if (
        decryptDataLocalStorage('subscriberDatabasePort') != null &&
        decryptDataLocalStorage('subscriberDatabasePort') != ''
      )
        SubscriberDatabasePort = decryptDataLocalStorage('subscriberDatabasePort').toString();
    }

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${resp.currentUser}`,
        'x-d4-sid': subscriberId,
        'x-d4-host': SubscriberHost,
        'x-d4-dbname': SubscriberDatabaseName,
        'x-d4-dbport': SubscriberDatabasePort,
        'x-d4-origin': 'web-D4',
        'x-d4-origin-name': window.location.hostname,
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
        'Cache-Control': 'no-cache',
      },
    });
  }
  return next(request);
}
